import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-343b8858"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Similar_target" }
const _hoisted_2 = { class: "select" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "tabs_content" }
const _hoisted_5 = { class: "tab_title" }
const _hoisted_6 = { class: "l_f" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "l_title" }, "标的编号: ", -1))
const _hoisted_9 = { class: "item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "l_title" }, "相似度: ", -1))
const _hoisted_11 = { class: "item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "l_title" }, "已理赔", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "r_f"
}
const _hoisted_15 = {
  key: 0,
  class: "cowDetail"
}
const _hoisted_16 = { class: "cell-item title" }
const _hoisted_17 = { class: "cowImgs" }
const _hoisted_18 = {
  key: 1,
  class: "cowDetail otherDetail"
}
const _hoisted_19 = { class: "cell-item title" }
const _hoisted_20 = {
  key: 0,
  class: "cowImgs"
}
const _hoisted_21 = {
  key: 1,
  class: "cowImgs flex"
}
const _hoisted_22 = {
  class: "video",
  controls: "",
  style: {"width":"200px","height":"100px"}
}
const _hoisted_23 = ["src"]
const _hoisted_24 = {
  key: 1,
  class: "pageination"
}
const _hoisted_25 = { class: "demo-image__preview" }

import { nextTick, ref, toRef, onMounted, watch, computed } from "vue";
import { tabsPageBase } from '@/utiles/utiles'
interface ResultTitle {
    [key: string]: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SimilarTarget',
  props: ['form', 'targetInfo', 'targetType','cosUrl','ossUrl'],
  setup(__props) {

const { form, targetInfo,  targetType,cosUrl,ossUrl } = __props;


const resultTitle: ResultTitle = {
    REPEAT: '投保标的',
    NORMAL: '本标的未做过承保验标',
};
const otherDetail = {
    '0': '其他照片',
    '1': '视频',
}
let activeName = ref('')
const previewList = ref([]);
const tabsPage = ref(1)
const tabsPageSize = ref(tabsPageBase.pageSize)
const showViewer = ref(false);
const setPicName = (picType: string) => {
    return picType == "FACE"
        ? "正脸:"
        : picType == "NOSE"
            ? "鼻纹:"
            : picType == "LEFT_FACE"
                ? "侧脸:"
                : picType == "RIGHT_FACE"
                    ? "右侧脸:"
                    : "";
};
onMounted(async () => {
    await nextTick()
    if (targetType == 'audited') {
        activeName.value = form.auditTargetId
    } else {
        activeName.value = simTargetAndsimtargetLow.value.length > 0 ? simTargetAndsimtargetLow.value[0].id : ''
    }
  console.log("oss:",ossUrl.value,"cos:",cosUrl.value,"targetInfo:",targetInfo.cosUrl)
})
// targetInfo.targetInfo.orderNo 有则 与本案件保单有关联 无则没有关联
let isRelated = computed(() => {

    return !!targetInfo.targetInfo.orderNo
})

const isSimTargetEmpty = computed(() => {
    return targetInfo.simTarget.length === 0;
});
const getTitleText = () => {
    if (targetType === 'AuditPage') {
        if (!isRelated.value) {
            return '本保单未做过承保验标';
        } else if (targetInfo.simTarget.length === 0) {
            return '本标的未做过承保验标';
        } else {
            return '承保库对比结果';
        }
    } else {
        return '承保库对比结果';
    }
};

const getTagType = () => {
    if (!isRelated.value) {
        return 'danger';
    }
    if (targetInfo.targetInfo.acceptTargetStatus === 'REPEAT') {
        return 'success';
    }
    return 'danger';
};

const getTagContent = () => {
    if (!isRelated.value) {
        return '本保单未做过承保验标';
    }
    if (targetInfo.targetInfo.acceptTargetStatus === 'REPEAT') {
        return '投保标的';
    }
    if (targetInfo.targetInfo.acceptTargetStatus === 'NORMAL') {
        if (targetInfo.targetInfo.verifyTargetOrCollarEnum === 'NONE') {
            return '与本保单投保标的相似度较低，请核对';
        }
        return '本标的未做过承保验标';
    }
    return '';
};
let simTargetAndsimtargetLow = computed<any[]>(() => {
    return [...targetInfo.simTarget.map((v: any) => {
        v.isExcThreshold = false
        return v
    }), ...targetInfo.simTargetLow.map((v: any) => {
        v.isExcThreshold = true
        return v
    })]
})
const simTargetOrder = computed<any[]>(() => {
    const order = ['FACE', 'NOSE', 'LEFT_FACE'];
    return simTargetAndsimtargetLow.value.map(item => ({
        ...item,
        picInfoVoList: item.picInfoVoList.sort((a, b) => {
            return order.indexOf(a.picType) - order.indexOf(b.picType);
        })
    }));
});
const simTarget = computed(() => {
    if (targetType === 'audited') {
        return simTargetOrder.value.filter((n: any) => form.auditTargetId === n.id)
    } else {
        return simTargetOrder.value || []
    }
})
const targetStatus = computed(() => { return targetInfo?.targetInfo?.acceptTargetStatus || '' })
const isShowSimTarget = computed(() => { return targetType == 'AuditPage' ? (targetInfo?.targetInfo?.acceptTargetStatus == 'REPEAT' ? form.auditStatus !== 'NORMAL' : form.auditStatus == 'REPEAT') : true })
const isDisabledRepeat = computed(() => { return targetInfo?.targetInfo?.acceptTargetStatus != 'REPEAT' && simTarget.value.length == 0 })
const clickImage = (image: string) => {
    previewList.value = [image];
    showViewer.value = true;
};

const tabsTable = (simTarget) => {
    let start = (tabsPage.value - 1) * tabsPageSize.value
    if (start >= simTarget.length) start = 0
    let end = tabsPage.value * tabsPageSize.value
    if (end >= simTarget.length) end = simTarget.length
    return simTarget.slice(start, end)
}
const handleCurrentChange = (val: number) => {
    tabsPage.value = val
    activeName.value = tabsTable(simTarget.value).length > 0 ? tabsTable(simTarget.value)[0].id : ''
}
const statusChange = (val: any) => {
    if (val == 'NORMAL') {
        form.auditTargetId = ''
    }
}
const submitAudit = (item: any) => {
    if (form.auditTargetId == item.id) {
        form.auditTargetId = ''
    } else {
        form.auditTargetId = item.id
    }
}
const getImageUrl = (fileId: any) => {
  return fileId.cloudServiceType === '1' ? ossUrl + fileId.url : cosUrl + fileId.url;
}

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: _normalizeClass({ red: !_unref(isRelated) && __props.targetType == 'AuditPage' })
        }, _toDisplayString(__props.targetType == 'AuditPage' ? (_unref(isRelated) ? '承保库对比结果' : '本保单未做过承保验标') : '承保库对比结果'), 3),
        (__props.targetType !== 'AuditPage')
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              class: "ml-2",
              effect: "plain",
              round: "",
              type: getTagType()
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(getTagContent()), 1)
              ]),
              _: 1
            }, 8, ["type"]))
          : _createCommentVNode("", true),
        (__props.targetType === 'AuditPage' && _unref(isRelated) && __props.targetInfo.simTarget.length === 0)
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 1,
              class: "ml-2",
              effect: "plain",
              round: "",
              type: "danger"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 本标的未做过承保验标 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      (__props.targetType !== 'COLLECTING')
        ? (_openBlock(), _createBlock(_component_el_form, {
            key: 0,
            inline: true,
            model: __props.form,
            class: "demo-form-inline"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "审核结果" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    disabled: __props.targetType == 'audited',
                    style: {"width":"150px"},
                    modelValue: __props.form.auditStatus,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.form.auditStatus) = $event)),
                    onChange: statusChange,
                    placeholder: "审核结果",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "非投保标的",
                        value: "NORMAL"
                      }),
                      _createVNode(_component_el_option, {
                        label: "投保标的",
                        disabled: _unref(isDisabledRepeat),
                        value: "REPEAT"
                      }, null, 8, ["disabled"])
                    ]),
                    _: 1
                  }, 8, ["disabled", "modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    (_unref(simTarget).length && _unref(isShowSimTarget))
      ? (_openBlock(), _createBlock(_component_el_tabs, {
          key: 0,
          modelValue: _unref(activeName),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(activeName) ? (activeName).value = $event : activeName = $event)),
          class: "demo-tabs"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabsTable(_unref(simTarget)), (item, index) => {
              return (_openBlock(), _createBlock(_component_el_tab_pane, {
                name: item.id,
                key: item.id
              }, {
                label: _withCtx(() => [
                  _createVNode(_component_el_badge, {
                    value: __props.form.auditTargetId == item.id && __props.targetType !== 'audited' ? '已确认' : '',
                    class: "item"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`标的${tabsPage.value == 1 ? index + 1 : ((tabsPage.value - 1) * _unref(tabsPageBase).pageSize) + index + 1}`), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _hoisted_8,
                          _createElementVNode("span", null, _toDisplayString(item.targetNo), 1)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _hoisted_10,
                          _createElementVNode("span", {
                            class: _normalizeClass(['font_b', (__props.targetType == 'AuditPage' || __props.targetType == 'COLLECTING') && (item.isExcThreshold ? 'red' : 'green')])
                          }, _toDisplayString((item.sim * 100).toFixed(2)) + "%", 3)
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_11, _hoisted_13, 512), [
                          [_vShow, item.claimFlag == 'Y']
                        ])
                      ]),
                      (__props.form.auditStatus == 'REPEAT')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _withDirectives(_createVNode(_component_el_button, {
                              plain: "",
                              onClick: ($event: any) => (submitAudit(item)),
                              type: "danger",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(__props.form.auditTargetId ==
                                        item.id ? '已确认标的' : '确认标的'), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]), [
                              [_vShow, __props.targetType !== 'audited']
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (item.picInfoVoList && item.picInfoVoList.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.picInfoVoList, (pics, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "cowItem",
                              key: index
                            }, [
                              _createElementVNode("div", _hoisted_16, _toDisplayString(setPicName(pics.picType)), 1),
                              _createElementVNode("div", _hoisted_17, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pics.fileIds, (value) => {
                                  return (_openBlock(), _createBlock(_component_el_image, {
                                    class: "cowImg",
                                    key: value.url,
                                    style: {"width":"100px","height":"100px"},
                                    src: getImageUrl(value),
                                    fit: "contain",
                                    onClick: ($event: any) => (clickImage(getImageUrl(value)))
                                  }, null, 8, ["src", "onClick"]))
                                }), 128))
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (item.otherFileInfoVoList && item.otherFileInfoVoList.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.otherFileInfoVoList, (items, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "cowItem",
                              key: index
                            }, [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_19, _toDisplayString(otherDetail[items.fileType]), 1),
                                (items.fileType == '0')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.fileIds, (value) => {
                                        return (_openBlock(), _createBlock(_component_el_image, {
                                          class: "cowImg",
                                          key: value.url,
                                          style: {"width":"100px","height":"100px"},
                                          src: getImageUrl(value),
                                          fit: "contain",
                                          onClick: ($event: any) => (clickImage(getImageUrl(value)))
                                        }, null, 8, ["src", "onClick"]))
                                      }), 128))
                                    ]))
                                  : (items.fileType == '1')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.fileIds, (value) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: value.url,
                                            class: "mr10"
                                          }, [
                                            _createElementVNode("video", _hoisted_22, [
                                              _createElementVNode("source", {
                                                src: getImageUrl(value),
                                                type: "video/mp4"
                                              }, null, 8, _hoisted_23),
                                              _createTextVNode(" Your browser does not support the video tag. ")
                                            ])
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_unref(simTarget).length && _unref(isShowSimTarget) && (__props.targetType == 'AuditPage' || __props.targetType == 'COLLECTING'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createVNode(_component_el_pagination, {
            background: "",
            layout: "prev, pager, next",
            onCurrentChange: handleCurrentChange,
            "current-page": tabsPage.value,
            "onUpdate:current-page": _cache[2] || (_cache[2] = ($event: any) => ((tabsPage).value = $event)),
            "page-size": tabsPageSize.value,
            total: _unref(simTarget).length
          }, null, 8, ["current-page", "page-size", "total"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_25, [
      (showViewer.value)
        ? (_openBlock(), _createBlock(_component_el_image_viewer, {
            key: 0,
            "hide-on-click-modal": "",
            onClose: _cache[3] || (_cache[3] = () => { previewList.value.value = []; showViewer.value = false }),
            "url-list": previewList.value
          }, null, 8, ["url-list"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})